import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { app } from 'cbmms-js/web';
import styles from './Share.module.css';
import animStyles from 'ui/animation/animation.module.css';

export default class ShareBrowserAlert extends React.Component {
  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const { prevLocation, hideResolve } = state;

    if (
      !(
        prevLocation &&
        prevLocation.pathname === location.pathname &&
        prevLocation.search === location.search
      )
    ) {
      if (hideResolve) {
        hideResolve({ cancel: true });
      }

      return {
        prevLocation: location,
        hideResolve: null,
      };
    }

    return null;
  }

  state = {
    shareDict: {},
    prevLocation: null,
    hideResolve: null,
  };

  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
  }

  show(shareDict) {
    if (this.state.hideResolve) {
      this.state.hideResolve({ cancel: true });
    }

    return new Promise(resolve => {
      this.setState({ hideResolve: resolve, shareDict });
    });
  }

  hide(options) {
    if (this.state.hideResolve) {
      this.state.hideResolve(options);

      this.setState({ hideResolve: null });
    }
  }

  handleCancel = () => {
    this.hide({ cancel: true });
  };

  handleDone = () => {
    this.hide({ done: true });
  };

  handleCopy = () => {
    const urlInput = this.inputRef.current;

    if (!urlInput) {
      return;
    }

    urlInput.select();
    urlInput.setSelectionRange(0, 999999);

    try {
      document.execCommand('Copy');
      app.showTips('succ', '已复制链接');
    } catch (err) {
      app.showTips('error', '复制失败');
    }
    urlInput.blur();

    this.hide({ done: true });
  };

  render() {
    const { hideResolve, shareDict } = this.state;

    return (
      <CSSTransition
        in={!!hideResolve}
        timeout={200}
        classNames={{
          enter: animStyles.slideInBottomEnter,
          enterActive: animStyles.slideInBottomEnterActive,
          exit: animStyles.slideInBottomExit,
          exitActive: animStyles.slideInBottomExitActive,
          exitDone: animStyles.slideInBottomExitDone,
        }}
        mountOnEnter
      >
        <div className={styles.alertWrapper}>
          <span
            onClick={this.handleCancel}
            className={animStyles.transparentMask}
          />
          <div className={animStyles.bottomModal}>
            <input
              type="text"
              defaultValue={shareDict.link}
              ref={this.inputRef}
              className={styles.copyUrlInput}
              readOnly
            />
            <div className={styles.shareBrowserModal}>
              <a
                href={`http://service.weibo.com/share/share.php?url=${encodeURIComponent(
                  shareDict.link
                )}&title=${shareDict.title}&pic=${
                  shareDict.imgUrl
                }&searchPic=false`}
                className={styles.shareBrowserItem}
                onClick={this.handleDone}
              >
                <span className={styles.shareBrowserIcon1} />
                <span className={styles.shareBrowserTitle}>新浪微博</span>
              </a>
              <a
                href={`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
                  shareDict.link
                )}&title=${shareDict.title}&pics=${shareDict.imgUrl}&summary=${
                  shareDict.desc
                }`}
                className={styles.shareBrowserItem}
                onClick={this.handleDone}
              >
                <span className={styles.shareBrowserIcon2} />
                <span className={styles.shareBrowserTitle}>QQ空间</span>
              </a>
              <span
                className={styles.shareBrowserItem}
                onClick={this.handleCopy}
              >
                <span className={styles.shareBrowserIcon3} />
                <span className={styles.shareBrowserTitle}>复制链接</span>
              </span>
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }
}
